module.exports = __webpack_public_path__ + "static/img/news.5397b7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image/news.jpg
// module id = Pim2
// module chunks = 1